/**
 * Token Configuration
 * Maps URL patterns to their corresponding token header names and store keys
 * Based on environment variable URLs from .env file
 * 
 * STEPS TO ADD A NEW TOKEN:
 * 1. Add the token to the Vuex store (state, mutation, getter)
 * 2. Add the token to the .env file (e.g. VUE_APP_INTERNAL_NEW_TOKEN)
 * 3. Update initializeTokens() in initTokens.js to load the token from env variable into the store
 * 
 * NOTE: storeKey refers to the Vuex store getter name, NOT the environment variable
 */

export const TOKEN_CONFIG = [
    {
        // For commission system APIs
        urlPattern: getDomainFromUrl(process.env.VUE_APP_COMM_PURENROLL_SYSTEM),
        headerName: 'X-Commission-Token',
        storeKey: 'commissionToken'
    },
    {
        // For admin system APIs
        urlPattern: getDomainFromUrl(process.env.VUE_APP_CORENROLL_SYSTEM_ADMIN),
        headerName: 'X-Commission-Token',
        storeKey: 'commissionToken'
    },
    {
        // For message center APIs
        urlPattern: getDomainFromUrl(process.env.VUE_APP_MESSAGE_CENTER_URL),
        headerName: 'X-Msgcenter-Token',
        storeKey: 'msgCenterToken'
    },
    {
        // For ticketing APIs
        urlPattern: getDomainFromUrl(process.env.VUE_APP_TICKETING_API),
        headerName: 'X-Ticketing-Token',
        storeKey: 'ticketingToken'
    },
    {
        // For payment APIs
        urlPattern: getDomainFromUrl(process.env.VUE_APP_PAYMENT_URL),
        headerName: 'X-Payment-Token',
        storeKey: 'paymentToken'
    },
];

/**
 * Get token configuration for a given URL
 * @param {string} url - The request URL
 * @returns {object|null} - Token configuration object or null if no match
 */
export function getTokenConfig(url) {
    if (!url) return null;
    
    // Find the first matching pattern
    const config = TOKEN_CONFIG.find(config => url.includes(config.urlPattern));
    
    return config || null;
}

function getDomainFromUrl(url) {
    try {
        const urlObj = new URL(url);
        return urlObj.hostname;
    } catch (error) {
        console.error('Invalid URL:', url);
        return null;
    }
}